import { cn } from "../foundations/cn.js";
import { FOCUS_RING } from "../foundations/interaction.js";

export interface SkipLinkProps {
  /** The main content's id, without `#`. */
  targetId: string;
  children?: string;
  className?: string;
}

/** "Skip to content" (WCAG 2.4.1): the page's first focusable element, shown only on focus. */
export function SkipLink({ targetId, children = "Skip to content", className }: SkipLinkProps) {
  return (
    <a
      href={`#${targetId}`}
      className={cn(
        "fixed top-2 left-2 z-[100] inline-flex h-control-md items-center rounded-control bg-bg-raised px-4 font-body text-body-b2-strong text-text-primary not-focus:sr-only",
        FOCUS_RING,
        className,
      )}
    >
      {children}
    </a>
  );
}
